import React, { Component } from 'react';
import { connect } from 'react-redux';
import Window from '../../generic-components/contracting-window';
// import ThreeDotsMenu from './three-dots-menuItems';
import { FlatButton, IconButton, FontIcon, IconMenu, MenuItem } from 'material-ui';
import HotelIcon from 'material-ui/svg-icons/maps/hotel';
import ExploreIcon from 'material-ui/svg-icons/action/explore';
import TemplateDraftToolbar from './template-draft-toolbar/index';
import { push as pushAction } from 'react-router-redux';
import LeftNav from '../left-nav/left-nav';
import moment from 'moment';
import R from 'ramda';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { JiraFlatButton, SmallRaisedButton } from '../../../tc-ui/small-buttons';
import PickMasterBtnIndicator
  from '../../master-template/btns-switches/pick-master-button-n-indicator';
import WallWrapper from '../../../wall/wrapper';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

class DraftNTemplateWindowDataWrapper extends Component {
  constructor() {
    super();
    this.state = {
      showToolBar: true,
    };
  }
  toggleToolbar = () => this.setState({ showToolBar: !this.state.showToolBar })
  render() {
    const {
      children,
      actionsForLeftNav,
      actionsForMenu,
      actionsForContractWindow,
      // reducer -> leftNav data
      contractState,
      contractId,
      locationName,
      locationId,
      startDate,
      endDate,
      templateName,
      isLatest,
      draftErrorsExist,
      draftType,
      originFrom,
      templateVersions,
      allTemplateVersions,
      threadId,
      supplierInfo = {},
      supplierEditable,
      // reducer -> rightsideContent data
      productType,
      productName,
      productId,
      ratePackageIndex,
      ratePackageName,
      policyNotesTemplateId,
      policyNotesTemplateName,
      // userReducer
      isShellAccount,
      productDoesnotExistInDoc,
      push,
      isDummyAccount,
      pureDocView,
    } = this.props;
    const updateProductName = () => actionsForMenu.openAddEditContractDialog({
      type: 'updateProductName',
      data: {
        title: 'Update Room/Product Name',
        newProductName: productName,
      },
    });
    const updateLocationName = () => actionsForMenu.openAddEditContractDialog({
      type: 'UpdateLocationName',
      data: {
        title: 'Update Location/Property Name',
        newLocationName: locationName,
      },
    });
    const updateContractPeriod = () => actionsForMenu.openAddEditContractDialog({
      type: 'UpdateContractPeriod',
      data: {
        title: 'Update Contract Period',
        newStartDate: startDate,
        newEndDate: endDate,
        startDate,
        endDate,
      },
    });
    const isADraft = contractState === 'draft' || contractState === 'publish-ready';
    const isEditedDraft = isADraft && originFrom === 'edited';
    const isContractDraft = isEditedDraft && draftType !== 'template';
    const versionsNode = (isLatest && templateVersions && templateVersions.length > 1) || (!isLatest && !isNilOrEmpty(allTemplateVersions)) ? (
      <IconMenu
        desktop
        style={{ marginLeft: '4px', cursor: 'pointer' }}
        iconButtonElement={<IconButton style={{ fontSize: '12px', padding: '0', width: '100%', height: '30px' }}><a>{`Version ${templateVersions.length}`}</a></IconButton>}
      >
        {
          (isLatest ? templateVersions : allTemplateVersions).map((version, i) => (
            <MenuItem
              key={i}
              disabled={version === contractId}
              primaryText={`Version ${i + 1}`}
              onTouchTap={() => actionsForContractWindow.changeLeftNavRoute(`/contracting/template/${version}/details`)}
            />))
        }
      </IconMenu>
    ) : ``;
    return (
      <Window
        leftNavNode={<LeftNav
          {...actionsForLeftNav}
          appBarBgColor={R.call(R.cond([
            [() => isADraft, R.always('#1c313a')],
            [() => isLatest, R.always('#005662')],
            [R.T, R.always('#373737')],
          ]))}
          leftNavTitle={isShellAccount ? '' : R.call(R.cond([
            [() => isContractDraft, R.always('Contract Draft')],
            [() => isADraft, R.always('Template Draft')],
            [R.T, R.always('Template')],
          ]))}
        />}
        headerBgColor={R.call(R.cond([
          [() => isADraft, R.always('#455a64')],
          [() => isLatest, R.always('#00838f')],
          [R.T, R.always('#616161')],
        ]))}
        title={
          isDummyAccount
          ? (
              <div>
                <div className="flex-center" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden', lineHeight: '48px' }}>
                  {locationName} &nbsp;
                  {
                    isADraft && (
                      <JiraFlatButton
                        label="Edit"
                        style={{ marginLeft: '4px' }}
                        labelPosition="before"
                        onClick={updateLocationName}
                        icon={<FontIcon className="tc-icon-mode_edit" style={{ color: '#5E6C84' }} />}
                      />
                    )
                  }
                </div>
                {
                  Boolean(supplierInfo.marketInfo) && (
                    <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' }}>({supplierInfo.marketInfo})</div>
                  )
                }
              </div>
            )
          : (
            <div>
              <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' }}>
                {templateName}{supplierInfo.marketInfo ? ` (${supplierInfo.marketInfo})` : ''}
              </div>
              <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' }}>{locationName}</div>
            </div>
          )
        }
        subtitle={{
          dateRange: (
            <div className="flex-center">
              {moment.utc(startDate).format('D MMM YYYY')} - {moment.utc(endDate).format('D MMM YYYY')}
              {
                isADraft && (
                  <JiraFlatButton
                    label="Edit"
                    style={{ marginLeft: '4px' }}
                    labelPosition="before"
                    onClick={updateContractPeriod}
                    icon={<FontIcon className="tc-icon-mode_edit" style={{ color: '#5E6C84' }} />}
                  />
                )
              }
            </div>),
          name: (<div style={{ display: 'flex', alignItems: 'center' }}>
            {Boolean(productId && productType === 'Accommodation') && <HotelIcon/>}
            {Boolean(productId && productType === 'Non-Accommodation') && <ExploreIcon/>}
            <div style={{ maxWidth: isADraft ? '400px' : '300px', marginLeft: productId ? '12px' : '0', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
              {productName} {ratePackageName ? ` - ${ratePackageName}` : ''}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {
                Boolean(productId && isADraft && !productDoesnotExistInDoc && isDummyAccount) && (
                  <JiraFlatButton
                    label="Edit Name"
                    style={{ marginLeft: '4px' }}
                    labelPosition="before"
                    onClick={updateProductName}
                    icon={<FontIcon className="tc-icon-mode_edit" style={{ color: '#5E6C84' }} />}
                  />
                )
              }
              {
                Boolean(productId && isADraft && !productDoesnotExistInDoc) && (
                  <JiraFlatButton
                    label="Remove"
                    labelStyle={{ color: '#f06292' }}
                    style={{ marginLeft: '4px' }}
                    labelPosition="before"
                    onTouchTap={() => actionsForContractWindow.deleteProductFromContract(contractId, ratePackageIndex, productName)}
                    icon={<DeleteIcon style={{ fill: '#f06292' }} />}
                  />
                )
              }
              {
                Boolean(!productId && !pureDocView) && (
                  <PickMasterBtnIndicator
                    templateDraftId={contractId}
                    masterTemplateType="policyNotes"
                    masterTemplateId={policyNotesTemplateId}
                    masterTemplateName={policyNotesTemplateName}
                    editable={isADraft}
                  />
                )
              }
            </div>
          </div>),
          versions: isADraft ? undefined : versionsNode,
        }}
        toolbarNode={
          isADraft && this.state.showToolBar && supplierEditable ? (
            <TemplateDraftToolbar/>
          ) : undefined
        }
        titleBarRightWidgets={pureDocView ? [] : [
          // isADraft ? <ThreeDotsMenu key="menu" {...actionsForMenu} productName={productName} ratePackageName={ratePackageName} /> : undefined,
          isADraft && (
            <FlatButton
              key="editTools"
              label={this.state.showToolBar ? 'Hide Toolbar' : 'Show Toolbar'}
              labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
              hoverColor="rgba(0, 0, 0, 0.15)"
              style={{ color: 'white', width: '165px' }}
              onTouchTap={this.toggleToolbar}
              labelPosition="before"
              icon={<FontIcon
                className={this.state.showToolBar ? 'tc-icon-keyboard_arrow_up2' : 'tc-icon-keyboard_arrow_down2'}
                style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }}
              />}
            />
          ),
          !isADraft && (
              <WallWrapper amazonOrange key="compare">
                <FlatButton
                  key="compare"
                  label="Compare with"
                  labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
                  hoverColor="rgba(0, 0, 0, 0.15)"
                  style={{ color: 'white', minWidth: '68px' }}
                  onClick={() => push(`/contracting/reports/diff/template/${contractId}?locationId=${locationId}&locationName=${locationName}`)}
                  labelPosition="before"
                  icon={<FontIcon className="tc-icon-swap_horiz" style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }} />}
                />
              </WallWrapper>
          ),
          !isADraft && !isDummyAccount && <FlatButton
            key="copy"
            label="Make a copy"
            labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
            hoverColor="rgba(0, 0, 0, 0.15)"
            style={{ color: 'white', minWidth: '68px' }}
            onTouchTap={() => actionsForContractWindow.openDialogSaveAsTemplate(contractId, { startDate, endDate })}
            labelPosition="before"
            icon={<FontIcon className="tc-icon-content_copy" style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }} />}
          />,
          <FlatButton
            key="Download"
            label="Review Rates"
            labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
            hoverColor="rgba(0, 0, 0, 0.15)"
            style={{ color: 'white', minWidth: '68px' }}
            onTouchTap={(e) => {
              if (draftErrorsExist) window.alert('Please complete the draft first');
              else actionsForContractWindow.downloadContractPdf(contractId, contractState, e.currentTarget);
            }}
            labelPosition="before"
            icon={<FontIcon className="tc-icon-get_app" style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }} />}
          />,
          !isADraft && isLatest ? <FlatButton
            key="edit"
            label="Edit"
            hoverColor="rgba(0, 0, 0, 0.15)"
            labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
            style={{ color: 'white', minWidth: '68px' }}
            onTouchTap={actionsForContractWindow.createNGoToDraft}
            labelPosition="before"
            icon={<FontIcon className="tc-icon-mode_edit" style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }} />}
          /> : undefined,
          threadId ? <SmallRaisedButton
            label="Activities"
            key="changelog"
            labelStyle={{ padding: '8px' }}
            style={{ borderRadius: '5px' }}
            secondary
            onClick={() => push(`/contracting/template/${threadId}/logs`)}
          /> : undefined,
        ]}
      >
        {children}
      </Window>
    );
  }
}


const mapStateToProps = (state, { reducerName }) => {
  const { contracting, user } = state;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const companyType = user.getIn(['user', 'type']);
  return ({
    companyType,
    isShellAccount: user.get('contractingShell') || false,
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    ...leftNav,
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
    draftErrorsExist: contracting[reducerName].get('draftErrors').toJS().errorExist,
    productName: contracting[reducerName].getIn(['rightSideContent', 'productName']),
    productId: contracting[reducerName].getIn(['rightSideContent', 'productId']),
    ratePackageIndex: contracting[reducerName].getIn(['rightSideContent', 'ratePackageIndex']),
    ratePackageName: contracting[reducerName].getIn(['rightSideContent', 'ratePackageName']),
    policyNotesTemplateId: contracting[reducerName].getIn(['rightSideContent', 'policyNotesTemplateId']),
    policyNotesTemplateName: contracting[reducerName].getIn(['rightSideContent', 'policyNotesTemplateName']),
    isDummyAccount: user.get('isDummyAccount'),
    pureDocView: user.get('pureDocView'),
  });
};
DraftNTemplateWindowDataWrapper.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, {
  push: pushAction,
})(DraftNTemplateWindowDataWrapper);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/draftNTemplate-window.jsx